module.exports = __webpack_public_path__ + "img/12222_22.54419605.png";